// extracted by mini-css-extract-plugin
export default {"wrapper":"BJZAp_","secondaryButton":"F437cj","primaryButton":"xKLHEq"};